const $ = require('rgs-jquery');
require('rgs-velocity-animate');

const dataApi = {
	'simple-accordion': function (target){
		$('.step-heading', target).on('click', function (e) {
			const openedElem = $(target).find('.step-body.active');
			const targetElem = $(e.target).closest('.step').children('.step-body');
			if (targetElem.is('.active')) {
				return;
			}
			if (openedElem) {
				openedElem.velocity('slideUp');
				openedElem.removeClass('active');
			}
			targetElem.velocity('slideDown');
			targetElem.addClass('active');
		});
	},
};

$(function () {
	const $target = $('.steps[data-steps]');
	const mode = $target.attr('data-steps');
	if (mode)		{
		dataApi[mode]($target);
	}
});
